import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    parentName: PropTypes.string,
    goUp: PropTypes.func.isRequired,
};

const defaultProps = {
    parentName: '',
};

function FolderTile(props) {
    return (
        <div className="tile">
            {props.parentName &&
                <h3 className="tile-title font-style-italic" title={props.parentName}>{props.parentName}</h3>
            }
            <div className="tile-actions">
                <button className="bare-text-button no-button-style" onClick={props.goUp}>
                    <span className="fa-stack fa-4x" aria-hidden="true">
                        <i className="fa fa-folder fa-stack-2x"></i>
                        <i className="fa fa-level-up fa-stack-1x color-body-text"></i>
                    </span>
                    <div className="action-label">Go Up</div>
                </button>
            </div>
        </div>
    );
}

FolderTile.propTypes = propTypes;
FolderTile.defaultProps = defaultProps;

export default FolderTile;
